<template>
  <div>
    <el-row>
      <el-col>
        <el-form size="small" :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="分类：">
            <el-select v-model="searchForm.CATALOG_ID" clearable filterable>
              <el-option v-for="item in catalogList" :key="item.ID" :label="item.CATALOG_NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.PRODUCT_NAME"></el-input>
          </el-form-item>
          <el-form-item label="客户：">
            <el-select size="medium" filterable v-model="searchForm.TC_ID" placeholder="请选择" clearable>
              <el-option v-for="item in companyLists" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户类型：" prop="CUSTOMER_TYPE">
            <el-select size="medium" filterable v-model="searchForm.CUSTOMER_TYPE" placeholder="请选择" clearable @change="$forceUpdate()">
              <el-option v-for="item in customerTypeLists" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="项目点：">
            <el-select filterable v-model="searchForm.PROJECT" placeholder="请选择" clearable>
              <el-option v-for="item in projects" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="日期范围：">
            <el-date-picker size="medium" unlink-panels v-model="searchForm.DATE" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="查询类型：">
            <el-select size="medium" filterable v-model="searchForm.查询类型" placeholder="请选择" clearable>
              <el-option v-for="item in 毛利表查询类型" :key="item.Stype" :label="item.NAME" :value="item.Stype"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" class="btn" @click="fliterData">筛选</el-button>
            <el-button size="medium" type="primary" plain class="btn" @click="exportForm">导出</el-button>
            <el-button size="medium" type="primary" plain class="btn" @click="exportSummary">项目点毛利汇总导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" max-height="520" stripe border>
          <el-table-column label="序号" type="index" width="50px"></el-table-column>
          <el-table-column label="项目点" prop="PROJECT_NAME" min-width="100px"></el-table-column>
          <el-table-column label="客户类型" prop="TYPE" min-width="100px"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE" min-width="100px"></el-table-column>
          <el-table-column label="品名" prop="NAME" min-width="100px"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION" min-width="100px"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT" min-width="100px"></el-table-column>
          <el-table-column label="销售数量" prop="SALE_COUNT" min-width="100px"></el-table-column>
          <el-table-column label="销售均价" prop="SALE_PRICE" min-width="100px"></el-table-column>
          <el-table-column label="收入金额" prop="SALE_TOTAL_FEE" min-width="100px"></el-table-column>
          <el-table-column label="出库数量" prop="STOCK_OUT_COUNT" min-width="100px"></el-table-column>
          <el-table-column label="成本均价" prop="PURCHASE_PRICE" min-width="100px"></el-table-column>
          <el-table-column label="成本金额" prop="PURCHASE_TOTAL_FEE" min-width="100px"></el-table-column>
          <el-table-column label="毛利" prop="PROFIT" min-width="100px"></el-table-column>
          <el-table-column label="毛利率" prop="GROSS_MARGIN" min-width="100px"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { haveDSXMDFun } from 'api/sellOrder';
import http from '@/assets/common/http';
import { getFormatDay } from '@/assets/common/common';
import { getClassFun } from '@/assets/api/skuManage';

export default {
  data() {
    return {
      searchForm: {},
      catalogList: [],
      tableData: [],
      kinds: [],
      customer: [],
      companyLists: [],
      totalCount: 0,
      pageSize: 15,
      currentPage: 1,
      //   客户类型
      customerTypeLists: [
        { label: '内部项目', value: 1 },
        { label: '外部项目', value: 2 },
      ],
      毛利表查询类型: this.$util.毛利表查询类型(),
      //   项目点
      projects: [],
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.$set(this.searchForm, 'PRODUCT_NAME', this.$store.state.SINGLERANGE_ALL.PRODUCT_NAME);
    this.$set(this.searchForm, 'TC_ID', this.$store.state.SINGLERANGE_ALL.TC_ID);
    this.$set(this.searchForm, 'DATE', this.$store.state.SINGLERANGE_ALL.DATE);
    this.$set(this.searchForm, 'CATALOG_ID', this.$store.state.SINGLERANGE_ALL.CATALOG_ID);
    this.queryData();
    this.queryPro();
    this.queryProject();
    this.queryCatalog();
  },
  methods: {
    // 拉取客户公司和项目点
    queryProject() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 3,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        if (result.length > 0) {
          this.projects = result[0].project;
        } else {
          this.totalCount = 0;
          this.companyLists = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    // ----拉取项目点
    queryPro() {
      haveDSXMDFun().then((result) => {
        this.companyLists = result.length > 0 ? result[0].company : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 导出
    exportForm() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 76,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.CATALOG_ID) {
        params.CATALOG_ID = this.searchForm.CATALOG_ID;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.CUSTOMER_TYPE) {
        params.CUSTOMER_TYPE = this.searchForm.CUSTOMER_TYPE;
      }
      if (this.searchForm.PROJECT) {
        params.PROJECT_ID = this.searchForm.PROJECT;
      }
      if (this.searchForm.DATE && this.searchForm.DATE[0]) {
        params.START_DAY = this.searchForm.DATE[0];
        params.END_DAY = this.searchForm.DATE[1];
      } else {
        params.START_DAY = getFormatDay(-1, '-');
        params.END_DAY = getFormatDay(-1, '-');
      }
      if (this.searchForm.查询类型) {
        params.ORDER_SCALE = this.searchForm.查询类型;
      }
      http.post(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 筛选
    fliterData() {
      this.currentPage = 1;
      this.queryData();
    },
    // 获取界面数据
    queryData() {
      this.$store.dispatch('SINGLERANGE_ALL', {
        PRODUCT_NAME: this.searchForm.PRODUCT_NAME,
        TC_ID: this.searchForm.TC_ID,
        DATE: this.searchForm.DATE,
        CATALOG_ID: this.searchForm.CATALOG_ID,
      });
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 75,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
      };
      if (this.searchForm.CATALOG_ID) {
        params.CATALOG_ID = this.searchForm.CATALOG_ID;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.CUSTOMER_TYPE) {
        params.CUSTOMER_TYPE = this.searchForm.CUSTOMER_TYPE;
      }
      if (this.searchForm.PROJECT) {
        params.PROJECT_ID = this.searchForm.PROJECT;
      }
      if (this.searchForm.DATE && this.searchForm.DATE[0]) {
        params.START_DAY = this.searchForm.DATE[0];
        params.END_DAY = this.searchForm.DATE[1];
      } else {
        params.START_DAY = getFormatDay(-1, '-');
        params.END_DAY = getFormatDay(-1, '-');
      }
      if (this.searchForm.查询类型) {
        params.ORDER_SCALE = this.searchForm.查询类型;
      }
      http.post(params).then((result) => {
        if (result.length === 0) {
          this.tableData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'warning' });
        } else if (result.length != 0) {
          this.tableData = result[0].list;
          this.tableData.forEach((item) => {
            if (item.CUSTOMER_TYPE == 0) {
              item.TYPE = '';
            } else if (item.CUSTOMER_TYPE == 1) {
              item.TYPE = '内部项目';
            } else if (item.CUSTOMER_TYPE == 2) {
              item.TYPE = '外部项目';
            }
          });
          this.totalCount = result[0].TOTAL;
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 项目点毛利汇总
    exportSummary() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 77,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.CATALOG_ID) {
        params.CATALOG_ID = this.searchForm.CATALOG_ID;
      }
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.CUSTOMER_TYPE) {
        params.CUSTOMER_TYPE = this.searchForm.CUSTOMER_TYPE;
      }
      if (this.searchForm.PROJECT) {
        params.PROJECT_ID = this.searchForm.PROJECT;
      }
      if (this.searchForm.DATE && this.searchForm.DATE[0]) {
        params.START_DAY = this.searchForm.DATE[0];
        params.END_DAY = this.searchForm.DATE[1];
      } else {
        params.START_DAY = getFormatDay(-1, '-');
        params.END_DAY = getFormatDay(-1, '-');
      }
      if (this.searchForm.查询类型) {
        params.ORDER_SCALE = this.searchForm.查询类型;
      }
      http.post(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryCatalog() {
      getClassFun().then((result) => {
        if (result.length !== 0) {
          this.catalogList = result;
        } else {
          this.catalogList = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/tableManage/projectPointGrossProfitTable.vue